/* eslint-disable react-hooks/exhaustive-deps */
// src/context/IdContext.js
import { createContext, useEffect, useMemo, useState, useCallback } from "react";
import { useAuth } from "./AuthContext";
import { useContext } from "react";
import { db } from "../firebase/config";
import { collection, getDocs, query, where } from "firebase/firestore";


const OrganiceContext = createContext(null);
OrganiceContext.displayName = "OrganiceContext";

export const OrganiceProvider = ({ children }) => {
  const { user } = useAuth();
  // ---- Data / control ----
  const [ error, setError ] = useState(null);
  const [ groups, setGroups ] = useState([]);
  const [ kitProduc, setKitProduc ] = useState([]);
  const [ products,  setProducts] = useState([]);
  // fuera del componente
  const SA_ROLES = ["SA-001","SA-002","SA-003","SA-004","SA-005"];
  const AA_ROLES = ["AA-001","AA-002","AA-003"];
  // distribucion por ROL
  const isSA = useMemo(() => SA_ROLES.includes(user?.rol), [user?.rol]);
  const isAA = useMemo(() => AA_ROLES.includes(user?.rol), [user?.rol]);
  // contador de tareas de arranque
  const [bootPending, setBootPending] = useState(0);
  const incBoot = useCallback(() => setBootPending(x => x + 1), []);
  const decBoot = useCallback(() => setBootPending(x => Math.max(0, x - 1)), []);
  // eslint-disable-next-line no-unused-vars
  const bootDone = bootPending === 0;
  // Unico llamado de grupos si el usuario es Admin
  useEffect(() => {
    let alive = true;
    if (!isAA && !isSA) return;
    if (isAA && !user?.idc) return;
    incBoot();
    (async () => {
        try {
          let q;
          if(isAA){
            q = query(collection(db,'equipment_group'),where('idc', '==', user.idc));
          } else {
            q = collection(db,'equipment_group');
          }
          const querySnapshot = await getDocs(q);
          const fetchedInfo = querySnapshot.docs.map(doc => ({
              id: doc.id,
              ...doc.data(),
          }));
          if (alive) setGroups(fetchedInfo);
        } catch (e) {
          if (alive) setError(e);
          console.error("Error fetching grupos:", e?.code || e?.message || e);
        } finally {
          if (alive) decBoot();
        }
    })();
    return () => { alive= false; }
  }, [user?.idc, isAA, isSA]);
  // Llamado de datos de kits de compañia
  useEffect(() => {
    let alive = true;
    if (!isAA && !isSA) return;
    if (isAA && !user?.idc) return;
    incBoot();
    (async () => {
        try {
          let q;
          if(isAA){
            q = query(collection(db,'produc_kits'),where('idc', '==', user.idc));
          } else {
            q = collection(db,'produc_kits');
          }
          const querySnapshot = await getDocs(q);
          const fetchedInfo = querySnapshot.docs.map(doc => ({
              id: doc.id,
              ...doc.data(),
          }));
          if (alive) setKitProduc(fetchedInfo);
        } catch (e) {
          if (alive) setError(e);
          console.error("Error fetching grupos:", e?.code || e?.message || e);
        } finally {
          if (alive) decBoot();
        }
    })();
    return () => { alive= false; }
  }, [user]);
  // Llamado de productos disponible para kits
  useEffect(() => {
    let alive = true;
    if (!user?.idc) return;
    incBoot();
    (async () => {
      try {
        // Paso 1: Obtener documentos de 'assignment' con el id_company deseado
        const assignmentRef = collection(db, 'assignment');
        const q = query(assignmentRef, where('id_company', '==', user.idc));
        const assignmentSnapshot = await getDocs(q);
        // Paso 2: Extraer todos los IDs de productos de los documentos obtenidos
        let productIds = [];
        assignmentSnapshot.forEach((doc) => {
          const data = doc.data();
          if (Array.isArray(data.selectProduc)) {
            productIds = productIds.concat(data.selectProduc);
          }
        });
        // Paso 3: Eliminar duplicados
        const uniqueProductIds = [...new Set(productIds)];
        // Paso 4: Obtener los documentos de 'produc' cuyos IDs estén en la lista
        const productsRef = collection(db, 'produc');
        const productsSnapshot = await getDocs(productsRef);
        const filteredProducts = [];
        productsSnapshot.forEach((doc) => {
          if (uniqueProductIds.includes(doc.id)) {
            filteredProducts.push({ 
                id: doc.id, 
                stock_type:"rental",
                ...doc.data() 
            });
          }
        });
        const CollectionRef = collection(db, 'base_product_stock_company');
        const u = query( CollectionRef, where('idc', '==', user.idc));
        const querySnapshot = await getDocs(u);
        const produc = querySnapshot.docs.map(doc => ({
            id: doc.id,
            stock_type:"own",
            ...doc.data()
        }));
        if (alive) setProducts([...filteredProducts, ...produc]);
      } catch (e) {
        if (alive) setError(e);
        console.error('Error fetching filtered products:', e);
      } finally {
        if (alive) decBoot();
      }
    })();
    return () => { alive= false; }
  }, [user.idc, isAA]);


  // Valor del contexto (memo para evitar renders)
  const value = useMemo(
    () => ({
      error,
      groups,
      setGroups,
      kitProduc,
      setKitProduc,
      products
    }),
    [ 
      error,
      groups,
      setGroups,
      kitProduc,
      setKitProduc,
      products
    ]
  );
  return <OrganiceContext.Provider value={value}>{children}</OrganiceContext.Provider>;
};

export const useOrganiceContext = () => {
  const ctx = useContext(OrganiceContext);
  if (!ctx) throw new Error("useOrganiceContext debe usarse dentro de <OrganiceProvider>.");
  return ctx;
};

